import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import ReactShowMoreText from "react-show-more-text";

const TextToggle = ({ text, maxLines, parentRef, buttonSx = {}, showMoreText = "", showlessText = "" }) => {
    const executeOnClick = (isExpanded) => {};
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((event) => {
            setWidth(event[0].contentBoxSize[0].inlineSize);
        });

        if (parentRef && parentRef.current) {
            resizeObserver.observe(parentRef.current);
        }
    }, [parentRef]);

    return (
        <Box>
            <ReactShowMoreText
                /* Default options */
                lines={maxLines}
                more={
                    <Box component={"span"} sx={{ color: "#444CE7", textDecoration: "underline", ...buttonSx }}>
                        {showMoreText || "Show more"}
                    </Box>
                }
                less={
                    <Box component={"span"} sx={{ color: "#444CE7", textDecoration: "underline", ...buttonSx }}>
                        {showlessText || "Show less"}
                    </Box>
                }
                onClick={executeOnClick}
                width={width}
                truncatedEndingComponent={"... "}>
                {typeof text === "string" ? (
                    <div dangerouslySetInnerHTML={{ __html: text?.replace(/\n/g, "<br>") }} />
                ) : (
                    text
                )}
            </ReactShowMoreText>
        </Box>
    );
};

export default TextToggle;
